export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();
  const wsUrl = config.public.NUXT_PUBLIC_WS_URL as string;

  // Diese 'listeners' Map ist der Knackpunkt
  let listeners: Record<string, Function[]> = {}; // Wichtig: Ist sie immer die gleiche Instanz?

  let socket: WebSocket | null = null;
  let isConnected = false;

  const connect = () => {
    socket = new WebSocket(wsUrl);

    socket.onopen = () => {
      isConnected = true;
    };

    socket.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        if (data?.event && listeners[data.event]) {
          listeners[data.event].forEach((fn, index) => {
            fn(data);
          });
        } else {
          console.warn('[realtimeSync Plugin] No matching listener found or "event" property missing.', { data, availableListeners: Object.keys(listeners) });
        }
      } catch (e) {
        console.error('[realtimeSync Plugin] Invalid JSON received from WS. Raw data:', event.data, 'Error:', e);
      }
    };

    socket.onclose = () => {
      isConnected = false;
      setTimeout(connect, 3000);
    };

    socket.onerror = (error) => {
      // console.error('[realtimeSync Plugin] WebSocket Error (connection/socket error):', error);
      if (!isConnected) {
         console.warn('[realtimeSync Plugin] Error, attempting to reconnect...');
         setTimeout(connect, 3000);
      }
    };
  };

  const send = (message: any) => {
    if (!socket || socket.readyState !== WebSocket.OPEN) {
      console.warn('[realtimeSync Plugin] Not connected. Message not sent:', message);
      return;
    }
    const payload = typeof message === 'string' ? message : JSON.stringify(message);
    socket.send(payload);
  };

  const on = (event: string, handler: Function) => {
    if (!listeners[event]) {
      listeners[event] = [];
    }
    listeners[event].push(handler);
  };

  connect();

  const realtimeSync = {
    send,
    on,
    isConnected: () => isConnected
  };

  nuxtApp.provide('realtimeSync', realtimeSync);
});